import { render, staticRenderFns } from "./SocialLogin.vue?vue&type=template&id=cc53e8b8&scoped=true"
import script from "./SocialLogin.vue?vue&type=script&lang=js"
export * from "./SocialLogin.vue?vue&type=script&lang=js"
import style0 from "./SocialLogin.vue?vue&type=style&index=0&id=cc53e8b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc53e8b8",
  null
  
)

export default component.exports